import type { MobileAndDesktopSources } from '@farmersdog/corgi-x';

import {
  desktopLovedByHumans,
  mobileLovedByHumans,
} from 'src/pages/Home/components/AssetPreloader/assets/loved-by-humans';

export const homepageHeroAssets: MobileAndDesktopSources = {
  mobileSources: mobileLovedByHumans,
  desktopSources: desktopLovedByHumans,
};
